import SolicitacaoCursoEventoServico from './componentes/SolicitacaoCursoEventoServico.vue';
import SolicitacaoCursoEventoServicoLista from './componentes/SolicitacaoCursoEventoServicoLista.vue';
import SolicitacaoCursoEventoServicoForm from './componentes/SolicitacaoCursoEventoServicoForm.vue';
import SolicitacaoCursoEventoServicoRelatorio from './componentes/SolicitacaoCursoEventoServicoRelatorio.vue';

export default {
  path: '/solicitacao-curso-evento-servico',
  component: SolicitacaoCursoEventoServico,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoCursoEventoServicoLista,
      name: 'solicitacao-curso-evento-servico',
    },
    {
      path: 'nova',
      component: SolicitacaoCursoEventoServicoForm,
      name: 'solicitacao-curso-evento-servico.nova',
    },
    {
      path: ':idCript',
      component: SolicitacaoCursoEventoServicoForm,
      name: 'solicitacao-curso-evento-servico.editar'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoCursoEventoServicoRelatorio,
      name: 'solicitacao-curso-evento-servico.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-curso-evento-servico/rotas.js